import { clsx } from 'clsx';

type AuthBrandMarkProps = {
  className?: string;
};

/**
 * App logo + wordmark for auth pages (uses public/newlogo.svg).
 */
export function AuthBrandMark({ className }: AuthBrandMarkProps) {
  return (
    <div
      className={clsx('inline-flex items-center gap-2.5', className)}
      aria-label="Trove"
    >
      {/* Fixed box + centered SVG avoids baseline gap and misalignment from inline <img> */}
      <span className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-md bg-transparent">
        <img
          src="/newlogo.svg"
          alt=""
          width={36}
          height={36}
          className="block h-full w-full object-contain object-center bg-transparent [background:none]"
          decoding="async"
        />
      </span>
      <span className="flex h-9 items-center text-xl font-bold leading-none tracking-tight text-foreground">
        Trovepile
      </span>
    </div>
  );
}
